import { useEffect, useRef, useState } from "react";

export function useDictation() {
  const [isListening, setIsListening] = useState(false);

  // transcript now includes a sessionId so we can ignore stale transcripts
  const [transcript, setTranscript] = useState<{ sessionId: number; text: string } | null>(null);

  const recognitionRef = useRef<any>(null);

  // dictation session ID increments every time user starts dictation
  const sessionIdRef = useRef(0);

  useEffect(() => {
    const SpeechRecognition =
      (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    if (!SpeechRecognition) {
      console.warn("Speech recognition not supported in this browser.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.continuous = false;
    recognition.interimResults = true;

    recognition.onresult = (event: any) => {
      let text = "";
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        text += event.results[i][0].transcript;
      }

      // Emit transcript WITH session ID
      setTranscript({
        sessionId: sessionIdRef.current,
        text,
      });
    };

    recognition.onend = () => setIsListening(false);

    recognitionRef.current = recognition;
  }, []);

  const toggle = () => {
    if (!recognitionRef.current) return;
  
    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
  
      // Return the existing session ID (still active until stop)
      return sessionIdRef.current;
    }
  
    // Start fresh dictation session
    sessionIdRef.current += 1;
    const newSessionId = sessionIdRef.current;
  
    // Clear old transcript
    setTranscript({ sessionId: newSessionId, text: "" });
  
    recognitionRef.current.start();
    setIsListening(true);
  
    // Return the new session ID so ChatInput can use it
    return newSessionId;
  };
  

  return { transcript, isListening, toggle };
}
